import React from 'react';
import { Link } from 'react-router-dom';
import errorHeading from '../assets/images/error-page/error-page-heading.png';
import errorBody from '../assets/images/error-page/error-page-body.png';
import errorBody2 from '../assets/images/error-page/e-p-body2.png';
import errorBody3 from '../assets/images/error-page/e-p-body3.png';
import bannerVector from '../assets/images/banner/banner-vector.png';

const NotFound: React.FC = () => {
  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-center py-10 px-4">
      {/* Heading Image */}
      <img
        src={errorHeading}
        alt="Error Heading"
        className="mb-6 mt-6"
      />

      {/* Body Image Stack with Vector at center */}
      <div className="relative flex justify-center mt-8">
        {/* Yellow 404 - bottom layer, most shifted right */}
        <img
          src={errorBody3}
          alt="Error Body Yellow"
          className="error-body absolute"
          style={{ bottom: '2px', left: '50%', transform: 'translateX(calc(-50% + 16px))', zIndex: 1 }}
        />
        {/* Orange 404 - middle layer, slightly shifted right */}
        <img
          src={errorBody2}
          alt="Error Body Orange"
          className="error-body absolute"
          style={{ bottom: '12px', left: '50%', transform: 'translateX(calc(-50% + 8px))', zIndex: 2 }}
        />
        {/* Green 404 - top layer, centered */}
        <img
          src={errorBody}
          alt="Error Body Green"
          className="error-body relative mt-6 mb-6"
          style={{ zIndex: 3 }}
        />
        {/* Vector ornament at center of 0 */}
        <img
          src={bannerVector}
          alt="Decorative"
          className="error-vector"
          style={{ zIndex: 5 }}
        />
      </div>

      {/* Hindi Text */}
      <p className="error-text text-center mt-4">
        ये आप कहाँ आ गए
      </p>

      {/* Something went wrong */}
      <p className="error-text text-center">
        Something went wrong
      </p>

      {/* Spanish text */}
      <p className="error-text text-center mb-6">
        No se encontró ninguna página.
      </p>

      {/* GO BACK TO HOME Button */}
      <Link to="/">
        <div className="error-btn-wrapper">
          <span className="error-btn font-teko font-normal text-white block transition-all duration-200 hover:translate-y-[4px] hover:bg-green-600">
            GO BACK TO HOME
          </span>
        </div>
      </Link>

      {/* Responsive Styles */}
      <style>{`
        /* Default - Desktop */
        .error-heading {
          width: 390px;
          height: 93px;
          max-width: 90%;
        }
        .error-body {
          width: 980px;
          height: 450px;
          max-width: 90%;
        }
        .error-vector {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 180px;
          height: 180px;
        }
        .error-text {
          font-family: 'Teko', sans-serif;
          font-size: 34px;
          font-weight: 400;
          color: #000000;
          padding: 0;
        }
        .error-btn-wrapper {
          box-shadow: 0 4px 0 0 #151515;
          border-radius: 8px;
        }
        .error-btn {
          background-color: #027C3F;
          padding: 15px 20px;
          font-size: 26px;
          width: 210px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #151515;
          cursor: pointer;
          border-radius: 8px;
        }

        /* Laptop (1024px - 1279px) */
        @media (min-width: 1024px) and (max-width: 1279px) {
          .error-body {
            width: 900px;
            height: 420px;
          }
          .error-vector {
            width: 100px;
            height: 100px;
          }
          .error-text {
            font-size: 30px;
          }
        }

        /* Tablet (768px - 1023px) */
        @media (min-width: 768px) and (max-width: 1023px) {
          .error-heading {
            width: 320px;
            height: 76px;
          }
          .error-body {
            width: 700px;
            height: 330px;
          }
          .error-vector {
            width: 80px;
            height: 80px;
          }
          .error-text {
            font-size: 28px;
          }
          .error-btn {
            width: 160px;
            height: 45px;
            font-size: 16px;
          }
        }

        /* Mobile (below 768px) */
        @media (max-width: 767px) {
          .error-heading {
            width: 250px;
            height: 60px;
          }
          .error-body {
            width: 100%;
            height: auto;
          }
          .error-vector {
            width: 60px;
            height: 60px;
          }
          .error-text {
            font-size: 24px;
          }
          .error-btn-wrapper {
            box-shadow: 0 3px 0 0 #151515;
          }
          .error-btn {
            width: 150px;
            height: 42px;
            font-size: 15px;
            padding: 12px 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default NotFound;
